<template lang="pug">
  main
    NavBarRequisiciones
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Compras - Requisiciones&nbsp
              a.button.is-black.is-rounded(@click='backPage')
                i.fas.fa-times
        .columns.has-text-centered.is-centered.is-multiline
          .column.is-3
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-clipboard-list.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Solicitudes
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Solicitudes") Entrar
          .column.is-3
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-clipboard-list.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Cotizaciones
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Cotizaciones") Entrar
          .column.is-3
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-cart-arrow-down.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Compras
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Compras-Solicitudes/Menu") Entrar

          .columns.column-blanco  
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarRequisiciones from './layout/NavBarRequisicion.vue'
  export default {
    name: 'HomeComprasReq',
    components: { Loader, NavBarRequisiciones },
    data() {
      return {
        isLoading: true
      }
    },
    methods: {
      iniciarComponente() {
        setTimeout(() => {
          this.isLoading = false
        }, 350)
      },
      backPage () {
        this.$router.back()
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/Home.vue